<template>
  <StatsComponent />
</template>

<script>
// @ is an alias to /src
import StatsComponent from "@/sections/voiceplus/components/StatsComponent.vue";

export default {
  name: "Modules",
  components: {
    StatsComponent,
  },
};
</script>
